import type { User } from '@halo/chat-sdk';
import { useEffect, useState } from 'react';
import { useStaticAppStore } from './useStaticAppStore';

export function useUserInfoList<T extends User = User>(user_ids: string[] | undefined) {
  const { client } = useStaticAppStore();
  const [users, setUsers] = useState<T[]>([]);

  useEffect(() => {
    if (user_ids?.length && client) {
      const userIds = Array.isArray(user_ids) ? user_ids : [user_ids];
      const result = client.Api.user.resolveUsersInfo(userIds, (res) => {
        setUsers(res as T[]);
      });
      return result.removeListener;
    } else {
      setUsers([]);
    }
  }, [client, user_ids]);

  return {
    users,
  };
}
